
import { arrayOf, nullable, oneOfType, shape, string } from 'vue-types';
import { imageShape } from '~/constants/PropTypes';
export default {
  props: {
    title: oneOfType([string(), nullable()]),
    body: oneOfType([string(), nullable()]),
    visual: arrayOf(shape(imageShape).loose),
  },
  data() {
    return {
      flipped: false,
    };
  },
  methods: {
    onClick() {
      this.flipped = !this.flipped;
    },
  },
};
